<template>
  <div class="release">
    <!-- 心愿内容 -->
    <TitleBar :barObj="wishBar" />
    <!-- 昵称 -->
    <div class="name">
      <div class="title">昵称</div>
      <div class="input">
        <input placeholder="请输入您的昵称" v-model="user_nick" />
      </div>
    </div>
    <!-- 时间 -->
    <div class="time common_box">
      <div class="title">时间</div>
      <div class="input" @click="showPicker = true">
        <input
          type="text"
          placeholder="请选择时间"
          disabled
          v-model="wish_time"
        />
        <van-icon name="arrow" size="16px" color="#333" />
      </div>
    </div>
    <!--地区-->
    <div class="area common_box">
      <div class="title">地区</div>
      <div class="input" @click="showPop = true">
        <input
          type="text"
          placeholder="请选择地区"
          v-model="address"
          disabled
        />
        <van-icon name="arrow" size="16px" color="#333" />
      </div>
    </div>
    <!-- 内容 -->
    <div class="textarea">
      <div class="title">
        <span>内容</span>
      </div>
      <div class="textarea_box">
        <van-field
          v-model="wish_content"
          row="5"
          type="textarea"
          autosize
          show-word-limit
          maxlength="200"
          placeholder="请输入内容"
        />
      </div>
    </div>
    <!-- 心愿图片 -->
    <div class="imgUpload">
      <div class="title">图片</div>
      <van-uploader
        v-model="wish_imgs"
        :max-size="5 * 1024 * 1024"
        multiple
        max-count="12"
        preview-full-image
        accept="image/*,mp4/*"
      >
        <van-image src="http://img.wish.hebyun.com.cn/images/upload_add.png" />
      </van-uploader>
    </div>
    <div class="line"></div>
    <!-- 完成过程 -->
    <TitleBar :barObj="finishBar" />
    <!-- 过程 -->
    <div class="textarea">
      <div class="title">
        <span>过程</span>
      </div>
      <div class="textarea_box">
        <van-field
          v-model="compelete_content"
          row="5"
          type="textarea"
          autosize
          show-word-limit
          maxlength="2000"
          placeholder="请输入内容"
        />
      </div>
    </div>
    <!-- 完成图片 -->
    <div class="imgUpload">
      <div class="title">图片</div>
      <van-uploader
        v-model="compelete_imgs"
        :max-size="5 * 1024 * 1024"
        multiple
        max-count="12"
        preview-full-image
      >
        <van-image src="http://img.wish.hebyun.com.cn/images/upload_add.png" />
      </van-uploader>
    </div>
    <!-- 底部区域 -->
    <div class="footer">
      <Button :button="button" @click.native="publishBtn" />
      <Checkbox @changeState="change($event)">
        <div class="terms_texts" slot="checkText">
          <span class="terms_gray">我已阅读并同意</span>
          <span class="terms_red" @click="jumpProtocol">《隐私条款》</span>
          <span class="terms_gray">与</span>
          <span class="terms_red" @click="jumpProtocol">《免责声明》</span>
        </div>
      </Checkbox>
    </div>

    <van-popup v-model="showPicker" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :columns-order="['year', 'month', 'day']"
        :formatter="formatter"
        @cancel="onTimeOut"
        @confirm="onTimeIn"
        @changeFn="onShift"
        :max-date="maxDate"
      />
    </van-popup>
    <!--地区弹出层-->
    <van-popup v-model="showPop" round position="bottom">
      <van-picker
        title="地区"
        show-toolbar
        value-key="name"
        :columns="region"
        @confirm="handleConfirm"
        @cancel="handleCancle"
      />
    </van-popup>
    <div class="side_bars">
      <img
        src="http://img.wish.hebyun.com.cn/images/share_icon.png"
        @click="share"
      />
      <img
        src="http://img.wish.hebyun.com.cn/images/return_con.png"
        v-if="isFirstPage"
        @click="goback"
      />
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import Button from "@/components/Button";

import Checkbox from "@/components/Checkbox";

export default {
  name: "releaseStory",
  components: {
    TitleBar,
    Button,
    Checkbox,
  },
  data() {
    return {
      user_nick: "",
      wish_time: "",
      wish_content: "", //心愿内容;
      compelete_content: "", //完成内容;
      wish_imgs: [], // 心愿图片
      compelete_imgs: [], //完成图片
      checked: true, //复选框状态
      showPicker: false,
      //   时间选择器
      currentDate: new Date(),
      maxDate: new Date(),
      changeDate: new Date(),
      address: "",
      showPop: false,
      region: [],
      city: "",
      area: "",
      button: "发布",
      finishBar: {
        img: "http://img.wish.hebyun.com.cn/images/book.png",
        title: "完成过程",
      },
      wishBar: {
        img: "http://img.wish.hebyun.com.cn/images/heart.png",
        title: "心愿内容",
      },
      isFirstPage: false,
    };
  },
  created() {
    this.queryUserInfo();
    this.queryRegion();
    let isFirstPage = localStorage.getItem("isFirstPage");
    if (isFirstPage == "0") {
      this.isFirstPage = true;
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/protocol") {
      //判断是从哪个路由过来的，若是detail页面不需要刷新获取新数据，直接用之前缓存的数据即可
      to.meta.isBack = true;
    }
    // next();
    next();
  },
  activated() {
    if (!this.$route.meta.isBack || this.isFirstEnter) {
      // debugger;
      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      // 如果isFirstEnter是true，表明是第一次进入此页面或用户刷新了页面，需获取新数据
      this.user_nick = "";
      this.wish_time = "";
      this.address = "";
      this.wish_content = ""; //心愿内容;
      this.compelete_content = ""; //完成内容;
      this.wish_imgs = []; // 心愿图片
      this.compelete_imgs = []; //完成图片
      // 把数据清空，可以稍微避免让用户看到之前缓存的数据
      this.queryUserInfo();
      this.queryUserInfo();
      this.queryRegion();
    }
    // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    this.$route.meta.isBack = false;
    // 恢复成默认的false，避免isBack一直是true，导致每次都获取新数据
    this.isFirstEnter = false;
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    share() {
      var url = window.location.href;

      var msg = {
        shareTitle: "我为群众办实事 党员帮办微心愿",
        shareSummary: "提交心愿、认领心愿、互动点赞，请登录“冀云”客户端",
        shareUrl: url,
        shareImage: "http://img.wish.hebyun.com.cn/images/wyxShare.jpg",
      };
      const u = navigator.userAgent,
        app = navigator.appVersion;
      console.log(app);
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        window.webkit.messageHandlers.nativeShare.postMessage(
          JSON.stringify(msg)
        );
      } else {
        window.jsInterface.nativeShare(JSON.stringify(msg));
      }
    },
    // 接收复选框状态
    change(data) {
      this.checked = data;
    },
    // 点击隐私条款
    jumpProtocol() {
      this.$router.push("./protocol");
    },

    onOversize() {
      this.$toast("文件大小不能超过5MB");
    },

    // 是否展示发布圆梦故事按钮
    async queryUserInfo() {
      let { data } = await this.$api.queryUserInfo();
      if (data.type !== 3) {
        this.$router.replace("./login");
      }
    },
    // 时间选择 弹框的确认按钮
    formatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      return val;
    },
    handleCancle() {
      this.showPop = false;
    },
    handleConfirm(e) {
      this.address = e[0] + "·" + e[1];
      this.city = e[0];
      this.area = e[1];
      this.showPop = false;
    },
    // 查询地区
    async queryRegion() {
      let { data } = await this.$api.queryLevelRegion();
      this.region = data;
    },
    // 取消
    onTimeOut() {
      this.showPicker = true;
    },
    // 格式转化
    onShift() {
      this.changeDate = this.currentDate; // Tue Sep 08 2020 00:00:00 GMT+0800 (中国标准时间)
    },
    // 确认
    onTimeIn() {
      this.wish_time = this.timeFormat(this.currentDate);
      this.showPicker = false;
    },
    timeFormat(time) {
      // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let day = time.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      return year + "-" + month + "-" + day;
    },
    // 发布按钮
    async publishBtn() {
      console.log(this.wish_imgs);
      if (this.user_nick.trim().length === 0) {
        this.$toast("请输入您的昵称");
        return;
      }
      if (this.wish_time.trim().length === 0) {
        this.$toast("请选择时间");
        return;
      }
      if (this.city.trim().length === 0) {
        this.$toast("请选择地区");
        return;
      }
      if (this.wish_content.trim().length === 0) {
        this.$toast("请输入心愿内容");
        return;
      }
      if (this.compelete_content.trim().length === 0) {
        this.$toast("请描述完成过程");
        return;
      }
      if (this.checked === false) {
        this.$toast("请您勾选下方复选框");
        return;
      }

      let token = localStorage.getItem("uploadToken");

      let wish_imgs = [];
      let compelete_imgs = [];

      if (this.wish_imgs.length != 0) {
        let { data } = await this.$api.uploadFile(this.wish_imgs, token);
        wish_imgs = data;
      }
      if (this.compelete_imgs.length != 0) {
        let { data } = await this.$api.uploadFile(this.compelete_imgs, token);
        compelete_imgs = data;
      }

      let data = {
        user_nick: this.user_nick,
        wish_time: this.wish_time,
        city: this.city,
        area: this.area,
        wish_content: this.wish_content,
        compelete_content: this.compelete_content, //完成内容;
        wish_imgs: JSON.stringify(wish_imgs), // 心愿图片json;
        compelete_imgs: JSON.stringify(compelete_imgs), //完成图片json;
      };

      await this.$api.publishFruit(data);
      this.$toast("发布成功");
      setTimeout(() => {
        this.$router.push("./fruit");
      }, 2000);
    },
  },
};
</script>
<style lang="scss">
.release {
  .btn {
    position: static;
    width: 210px !important;
    height: 36px !important;
    margin-bottom: 26px !important;
    margin-left: auto;
  }
}
</style>
<style scoped lang="scss">
.release {
  padding: 0 20px 35px;
  width: 100%;
  box-sizing: border-box;
  min-height: 100vh;
  height: auto;
  background-color: #fff8d6;
  .title {
    font-size: 15px;
    line-height: 1;
    color: #333333;
    width: 32px;
    margin-right: 10px;
  }
  .name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 15px;
    width: 335px;
    .input {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 285px;
      height: 25px;
      background-color: #ffffff;
      border-radius: 10px;
      padding-left: 10px;
      input {
        text-align: left;
        font-size: 14px;
        color: #000000;
        background-color: transparent;
        border: 0;
        outline: 0;
        width: 100%;
      }
    }
  }
  .line {
    width: 375px;
    height: 4px;
    margin-left: -20px;
    background-color: #ffffff;
  }
  /* 底部区域 */
  .footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    .terms_texts {
      display: flex;
      align-items: center;
      .terms_gray {
        font-size: 11px;
        color: #999999;
      }
      .terms_red {
        font-size: 11px;
        color: #e60012;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.common_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 15px;
  width: 335px;
  .title {
    font-size: 15px;
    line-height: 1;
    color: #333333;
    width: 32px;
    margin-right: 10px;
  }
  .input {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 285px;
    height: 25px;
    background-color: #ffffff;
    border-radius: 10px;
    padding-left: 10px;
    input {
      text-align: left;
      font-size: 14px;
      color: #000000;
      background-color: transparent;
      border: 0;
      outline: 0;
      width: 100%;
    }
  }
}

.imgUpload {
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
  width: 335px;
  .title {
    font-size: 15px;
    line-height: 1;
    color: #333333;
    width: 1;
    margin-right: 10px;
  }
  /deep/.van-uploader {
    flex: 1;
  }
  /deep/.van-image {
    width: 68px;
    height: 68px;
  }
  /deep/.van-uploader__preview {
    margin: 0 7px 9px 0;
  }
  /deep/.van-uploader__preview:nth-child(4n) {
    margin: 0 0 9px 0;
  }
  /deep/.van-uploader__preview-delete {
    // position: static;
    width: 15px;
    height: 15px;
    right: -5px;
    top: -5px;
    border-radius: 50%;
    .van-uploader__preview-delete-icon {
      // right: -1px;
      // top: 0px;
      width: 15px;
      height: 15px;
      line-height: 15px;
    }
  }
}
.textarea {
  display: flex;
  justify-content: space-between;
  .title {
    font-size: 15px;
    line-height: 1;
    color: #333333;
    width: 32px;
    margin-right: 10px;
  }
  .textarea_box {
    flex: 1;
    position: relative;
    width: 295px;
    // height: 120px;
    background-color: #ffffff;
    border-radius: 10px;
    font-size: 13px;
    line-height: 1;
    color: #999999;
    overflow: hidden;
    margin-bottom: 22px;
    /deep/.van-cell {
      // height: 120px;
      padding: 9px;
      box-sizing: border-box;
    }
    /deep/.van-field__body {
      min-height: 90px;
    }
    /deep/.van-field__control {
      min-height: 90px;
      font-size: 14px;
      color: #000000;
      line-height: 1.4;
    }
  }
}
</style>
